import { Injectable } from '@angular/core';
import sweetalert from 'sweetalert2';
@Injectable()
export class SweetAlertService {

  public swal(settings: any) {
    return sweetalert.fire(settings);
  }

  public prompt(options: any) {
    const baseOptions = {
      showCancelButton: true,
      confirmButtonClass: 'btn btn-primary',
      confirmButtonText: 'Submit',
      input: 'text'
    };
    return sweetalert.fire({ ...baseOptions, ...options });
  }

  public queue(mixin: any, steps: any[]) {
    const baseOptions = {
      showCancelButton: true,
      confirmButtonClass: 'btn btn-primary'
    };

    return sweetalert.mixin({ ...baseOptions, ...mixin }).queue(steps);
  }

  public confirm(options: any) {
    const baseOptions = {
      showCancelButton: true,
      confirmButtonClass: 'btn btn-primary',
      confirmButtonText: 'Confirm',
      type: 'warning'
    };
    return sweetalert.fire({ ...baseOptions, ...options });
  }

  public alert(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      confirmButtonText: 'OK',
      type: 'info'
    };
    return sweetalert.fire({ ...baseOptions, ...options });
  }

  public question(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      type: 'question'
    };
    return this.alert({ ...baseOptions, ...options });
  }

  public success(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      type: 'success'
    };
    return this.alert({ ...baseOptions, ...options });
  }

  public error(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      type: 'error'
    };
    return this.alert({ ...baseOptions, ...options });
  }

  public warn(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      type: 'warning'
    };
    return this.alert({ ...baseOptions, ...options });
  }

  public info(options: any) {
    const baseOptions = {
      confirmButtonClass: 'btn btn-primary',
      type: 'info'
    };
    return this.alert({ ...baseOptions, ...options });
  }
}
